import snakecaseKeys from 'snakecase-keys'
import axiosIns from '@/plugins/axios'

export default {
  getReservations({
    date = null, from = null, to = null, withDetails = null,
  } = {}) {
    return axiosIns.get('/waiter/reservations', {
      params: snakecaseKeys({
        date, from, to, withDetails,
      }),
    })
  },

  getReservation(id) {
    return axiosIns.get(`/waiter/reservations/${id}`)
  },

  createReservation(params) {
    return axiosIns.post('/waiter/reservations', snakecaseKeys({ reservation: params }, { deep: true }))
  },

  updateReservation(id, params) {
    return axiosIns.put(`/waiter/reservations/${id}`, snakecaseKeys({ reservation: params }, { deep: true }))
  },

  deleteReservation(id) {
    return axiosIns.delete(`/waiter/reservations/${id}`)
  },

  // hallId / tableNumber / startAt は卓作成ウィザードからの上書き（未指定はBE側で予約の値にフォールバック）
  checkInReservation(id, { hallId = null, tableNumber = null, startAt = null } = {}) {
    const overrides = {}
    if (hallId) overrides.hallId = hallId
    if (tableNumber) overrides.tableNumber = tableNumber
    if (startAt) overrides.startAt = startAt

    return axiosIns.put(`/waiter/reservations/${id}/check_in`, snakecaseKeys(overrides))
  },

}
